import React, {useEffect} from 'react'
import { Link } from 'react-router-dom'
import { ArrowUpRight } from 'react-feather';

const NotFound = (props) => {

  // Adding custom class to body 
  useEffect(() =>{
    props.location.pathname === '/' ? document.body.classList.add("home-class") : document.body.classList.add("custom-class");

    // Clear hamburger menu
    document.body.classList.remove("menu-closed");
    document.body.classList.remove("menu-opened");
   })

  return (
    <div id="notfound">
      <div className="notfound">
        <div className="notfound-content-wrapper">
          <h1>404</h1>
          <h3>Page Not Found</h3>
          <p>The page you are looking for does not exist.</p>
          <Link to='/neworganic'>Go to Home <ArrowUpRight/></Link>
        </div>
      </div>
    </div>
  )
}

export default NotFound